import React from 'react';
import { Navigation } from './components/Navigation';
import { HeroSection } from './components/HeroSection';
import { StorySection } from './components/StorySection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { Footer } from './components/Footer';
import { BeamsBackground } from './components/BeamsBackground';
const testimonials = [{
  author: {
    name: 'Ivan Acuna',
    handle: 'Founder of The Cognitive Leverage Group',
    avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/kLLpjGYbKGxoj7t89f7CUU/headshot.png'
  },
  text: "Elliot is the friend, mentor, and partner everyone wishes they had. His ability to love, inspire, and pour belief into people is second to none. Because of him I've been able to work with publicly traded companies and people who I wouldn't have otherwise met. He's helped me dream big and even bought my mom lunch for her birthday. Elliot is the person everyone hopes to have in their corner, and I'm blessed to call him a friend."
}, {
  author: {
    name: 'Michael Castrilli',
    handle: 'Vice President of Brokerage Services at First Capital Property Group',
    avatar: 'https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/files/1c1dfa83-6b11-45ef-b174-d3a6137855b1/Michael_Castrilli.jpg'
  },
  text: "Last year's retreat was life changing for me. The stories of faith, perseverance, and wisdom shared by the speakers in Elliot Martinez's event, were life changing. I was able to implement all I learned and had one of the most successful years of my career in commercial real estate with completing $30 million in transactions."
}, {
  author: {
    name: 'Caleb Wampler',
    handle: 'Executive Director at Kingdom Encounters International',
    avatar: 'https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/files/e83dc781-32b0-4784-ae0b-067c906b091b/caleb.jpg'
  },
  text: 'Elliot Martinez is a master motivator. Through his unique experiences and stories, he has profoundly changed my life. He has provided me with invaluable insights and perspective, balancing reflection and challenge, which enabled me to launch my first business, scale it and make six figures. Now, as I embark on my second business, I feel fully equipped for the road ahead.'
}];
export function App() {
  return <BeamsBackground intensity="strong" data-id="element-0">
      <Navigation data-id="element-1" />
      <HeroSection data-id="element-2" />
      <StorySection data-id="element-3" />
      <TestimonialsSection title="Trusted by industry leaders" description="Join the people who's lives have been impacted by Elliot" testimonials={testimonials} data-id="element-4" />
      <Footer data-id="element-5" />
    </BeamsBackground>;
}